import { cn } from '@packages/ui/styling/cn';
import type { ComponentProps } from 'react';

type DisplayGroupNameProps = ComponentProps<'span'> & {
  name: string;
};

/**
 * Component to safely display the group name, which is
 * user-generated and might be extremely long or lack spaces.
 *
 * Always wraps (never truncated) since the group name is a heading-level
 * element that should be fully visible.
 */
export const DisplayGroupName = ({ name, className, ...props }: DisplayGroupNameProps) => {
  return (
    <span className={cn('wrap-anywhere', className)} {...props}>
      {name}
    </span>
  );
};
